var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShoppingBasket = function SvgShoppingBasket(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "shopping_basket_svg__a",
    width: 24,
    height: 24,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#shopping_basket_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.525 21q-.675 0-1.2-.413a2.1 2.1 0 0 1-.725-1.062l-2.55-9.25a1 1 0 0 1 .162-.875A.92.92 0 0 1 2 9h4.75l4.4-6.55a.94.94 0 0 1 .35-.325.96.96 0 0 1 .95 0q.225.125.35.325L17.2 9H22q.5 0 .788.4a1 1 0 0 1 .162.875l-2.55 9.25a2.1 2.1 0 0 1-.725 1.063 1.9 1.9 0 0 1-1.2.412zM5.5 19h13l2.2-8H3.3zm6.5-2q.825 0 1.412-.587Q14 15.825 14 15t-.588-1.412A1.93 1.93 0 0 0 12 13q-.825 0-1.412.588A1.93 1.93 0 0 0 10 15q0 .824.588 1.413Q11.175 17 12 17M9.175 9H14.8l-2.825-4.2z"
  }))));
};
export default SvgShoppingBasket;